import React, { Fragment } from 'react';
//import * as TabilityTypes from 'types';
import styled from 'styled-components';
import theme from 'theme';

import { Checkin, CheckinComment } from 'types';
import CommentBlock from 'panels/shared/CheckinComments/CommentBlock';
import NewCommentBlock from 'panels/shared/CheckinComments/NewCommentBlock';

const CommentContainer = styled.div`
  padding: 0px ${theme.spacing.x2};
`;

interface Props {
  checkin: Checkin;
  checkinComments: CheckinComment[];
  hideNewComment?: boolean;
  focusToNewComment?: boolean;
}

function CheckinTimelineComments(props: Props) {
  const { checkin, checkinComments, hideNewComment, focusToNewComment } = props;

  return (
    <Fragment>
      {checkinComments.map((checkinComment) => {
        return (
          <CommentContainer>
            <CommentBlock checkinComment={checkinComment} checkin={checkin} key={checkinComment.id} />
          </CommentContainer>
        );
      })}
      {(!hideNewComment || focusToNewComment) && (
        <CommentContainer>
          <NewCommentBlock checkin={checkin} focusToNewComment={focusToNewComment} />
        </CommentContainer>
      )}
    </Fragment>
  );
}

export default React.memo(CheckinTimelineComments);
